import { BatchType } from 'features/autocheck/types'
import { CallResourcesEnum } from 'features/calls/types'
import { CppuMenageQuery } from 'features/claims/claimTypes'

/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum RefreshIntervalsEnum {
  useClaims = 30000,
  useCurrentUserClaims = 30000,
  useCurrentUserCalls = 30000,
  useCallForTalkToPayorRepCalls = 1000,
  useServiceUnavailable = 30000,
}
export enum RelativeRootEnum {
  ddfColumnSettingsAvailable = 'ddfcolumnsettingsavailable',
  csvImportPreview = 'preview',
  csvImportPreviewSniff = 'previewsniff',
  health = 'health',
  entities = 'entities',
  enums = 'enum',
  entityBags = 'entitybags',
  csvImport = 'csvimport',
  kvpMaps = 'kvpmaps',
  kvpGetMapKeys = 'keys',
  kvpGetMapKey = 'key',
  kvpPatchPostMapKey = 'key',
  claims = 'claims',
  calls = 'calls',
  batches = 'batches',
  levelOfSupports = 'levelofsupports',
  downloadCallResource = 'jobs',
  supportedOperations = 'supportedoperations',
  downloadSpeed = 'download-test',
  uploadSpeed = 'upload-test',
  claimActivites = 'claim-activities',
  samplePdf = 'sample-pdf',
  latestEOBRequest = 'latest-eob-request',
  eobReceived = 'eobs-received',
  eobfax = 'eobfax',
  customer = 'customers',
  fileexchange = 'fileexchange',
  phoneNumber = 'phoneNumber',
  unmatchedEobs = 'unmatched-eobs',
  unSupportedFaxes = 'unsupported-faxes',
  serviceLineItems = 'service-line-items',
  oaiUsers = 'oaiusers',
  users = 'users',
  action = 'action',
  Enable = 'Enable',
  /* CPPU */
  cppuMenage = 'menages',
  cppuMenageUnlinkable = 'menages/unlinkable',
  cppuUsersCognitoRefresh = 'cognito-refresh',
  cppuCustomers = 'customers',
  cppuPractices = 'practices',
  cppuOaiUsers = 'oaiusers',
  customerPreference = 'preferences/customers',
  practicePreference = 'preferences/tenants',
  eobZipPartDetails = 'eob-zip-part-details',
  loginDetails = 'login-details',
}
/* eslint-enable @typescript-eslint/no-duplicate-enum-values */

const claimServiceApiPaths = {
  ddfColumSettingsAvailable: () => `${RelativeRootEnum.csvImport}/${RelativeRootEnum.ddfColumnSettingsAvailable}`,
  csvPreview: () => `${RelativeRootEnum.csvImport}/${RelativeRootEnum.csvImportPreview}`,
  csvPreviewSniff: () => `${RelativeRootEnum.csvImport}/${RelativeRootEnum.csvImportPreviewSniff}`,
  kvpGetMapKey: (key?: string) =>
    key
      ? `${RelativeRootEnum.kvpMaps}/${RelativeRootEnum.kvpGetMapKey}/${key}`
      : `${RelativeRootEnum.kvpMaps}/${RelativeRootEnum.kvpGetMapKeys}`,
  kvpPatchPostMapKey: (key: string) => `${RelativeRootEnum.kvpMaps}/${RelativeRootEnum.kvpPatchPostMapKey}/${key}`,
  health: (query = '') => `${RelativeRootEnum.health}${query}`,
  exportPdf: (eobId?: string, query = '') => `${RelativeRootEnum.eobfax}/${eobId}/export${query}`,

  downloadSpeedTest: (query = '') => `${RelativeRootEnum.health}/${RelativeRootEnum.downloadSpeed}${query}`,
  uploadSpeedTest: (query = '') => `${RelativeRootEnum.health}/${RelativeRootEnum.uploadSpeed}${query}`,

  entities: (query = '') => `${RelativeRootEnum.entities}${query}`,

  entityUniqueValues: (entityNameOrId: string, query = '') =>
    `${RelativeRootEnum.entities}/${entityNameOrId}/values${query}`,

  enumValues: (enumName: string) => `${RelativeRootEnum.enums}/${enumName}/values`,

  claimActivites: (oaiClaimId: string, query = '') =>
    `${RelativeRootEnum.claims}/${oaiClaimId}/${RelativeRootEnum.claimActivites}${query}`,

  claimCurrentEntityBag: (oaiClaimId: string, query = '') =>
    `${RelativeRootEnum.claims}/${oaiClaimId}/currentEntityBag${query}`,

  claimArchiveEntityBag: (query = '') => `${RelativeRootEnum.claims}/archive${query}`,

  claimBulkOwnerhsip: (query = '') => `${RelativeRootEnum.claims}/${query}`,

  claimEntityVersion: (oaiClaimId: string, entId: number) =>
    `${RelativeRootEnum.claims}/${oaiClaimId}/entityVersionHistory/${entId}`,

  claims: (query = '') => `${RelativeRootEnum.claims}${query}`,

  claimStatuses: () => `${RelativeRootEnum.claims}/claim-status`,
  detailedClaimStatuses: () => `${RelativeRootEnum.claims}/detailed-claim-status`,

  claim: (oaiClaimId: string, query = '') => `${RelativeRootEnum.claims}/${oaiClaimId}${query}`,
  diagnosticClaim: `${RelativeRootEnum.claims}/diagnostic`,

  claimCalls: (oaiClaimId: string, query = '') =>
    `${RelativeRootEnum.claims}/${oaiClaimId}/${RelativeRootEnum.calls}${query}`,

  claimEOBRequest: (oaiClaimId: string, query = '') =>
    `${RelativeRootEnum.claims}/${oaiClaimId}/${RelativeRootEnum.latestEOBRequest}${query}`,

  claimEOBReceived: (oaiClaimId: string, query = '') =>
    `${RelativeRootEnum.claims}/${oaiClaimId}/${RelativeRootEnum.eobReceived}${query}`,

  serviceLineItems: (oaiClaimId: string, query = '') =>
    `${RelativeRootEnum.claims}/${oaiClaimId}/service-line-items?${query}`,

  calls: (query = '') => `${RelativeRootEnum.calls}${query}`,

  levelOfSupports: (query = '') => `${RelativeRootEnum.levelOfSupports}${query}`,

  batches: (query = '') => `${RelativeRootEnum.batches}${query}`,
  batchesNotification: (query = '') => `${RelativeRootEnum.batches}/notification${query}`,

  batchClaimFilter: (query = '') => `${RelativeRootEnum.batches}/filtered-claims${query}`,

  customer: (customerId: string) => `${RelativeRootEnum.customer}/${customerId}`,

  batchCancel: (batchId: string, query = '') => `${RelativeRootEnum.batches}/${batchId}/cancel${query}`,

  batchUpgrade: (batchId: string, query = '') => `${RelativeRootEnum.batches}/${batchId}/upgrade${query}`,

  batchUpgradewithAutoCheck: (batchId: string, query = '') =>
    `${RelativeRootEnum.batches}/${batchId}/upgrade-with-autocheck${query}`,

  batchResults: (batchId: string, query = '') => `${RelativeRootEnum.batches}/${batchId}/${query}`,

  batchArchive: (query = '') => `${RelativeRootEnum.batches}/${query}`,

  batchExport: (batchId: string, query = '') =>
    `${RelativeRootEnum.batches}/${batchId}/processing-results/export${query}`,

  batchExport2: (batchId: string, exportType: string, query = '') =>
    `${RelativeRootEnum.batches}/${batchId}/${exportType}/export${query}`,

  batchLineItemExport: (batchId: string, query = '') =>
    `${RelativeRootEnum.batches}/${batchId}/service-line-items/export${query}`,

  batchClaimsExport: (batchId: string, type: string) =>
    `${RelativeRootEnum.batches}/${batchId}/validation-results/export/${type}`,

  batchEOBExport: (batchId: string, query = '') => `${RelativeRootEnum.batches}/${batchId}/eob/export/${query}`,

  batchEOBPartDetails: (batchId: string, query = '') =>
    `${RelativeRootEnum.batches}/${batchId}/${RelativeRootEnum.eobZipPartDetails}${query}`,

  getPreSignedUrl: (url: string, query = '') => `${RelativeRootEnum.batches}/${url}${query}`,

  checkBatchStatus: (query = '') => `${RelativeRootEnum.batches}/settings${query}`,

  uploadBatch: (type: BatchType, repeatedCalls: boolean) =>
    `${RelativeRootEnum.batches}/upload?batchType=${type}&repeatCallFlag=${repeatedCalls}`,

  supportedOperations: (query = '') =>
    `${RelativeRootEnum.levelOfSupports}/${RelativeRootEnum.supportedOperations}${query}`,

  call: (callId: string, query = '') => `${RelativeRootEnum.calls}/${callId}${query}`,

  callDetails(claimId: string, callId: string): string {
    return `${RelativeRootEnum.calls}/call-detail/${claimId}/${callId}`
  },

  claimComments: (oaiClaimId: string, query = '') => `${RelativeRootEnum.claims}/${oaiClaimId}/notes?${query}`,

  batchCalls: () => `${RelativeRootEnum.claims}/queue-calls`,
  batchErrors: (batchId: string) => `${RelativeRootEnum.batches}/${batchId}/errors`,

  fileShare: (query = '') => `${RelativeRootEnum.fileexchange}/${query}`,
  phoneNumber: (query = '') => `${RelativeRootEnum.phoneNumber}/${query}`,
  customerBatchCount: () => `${RelativeRootEnum.batches}/customer-batch-count`,
  unmatchedEobs: (query = '') => `${RelativeRootEnum.eobfax}/${RelativeRootEnum.unmatchedEobs}${query}`,
  unSupportedFaxes: (query = '') => `${RelativeRootEnum.eobfax}/${RelativeRootEnum.unSupportedFaxes}${query}`,
  unmatchedEobDownload: (query = '') =>
    `${RelativeRootEnum.eobfax}/${RelativeRootEnum.unmatchedEobs}/download?${query}`,
  unSupportedFaxDownload: (query = '') =>
    `${RelativeRootEnum.eobfax}/${RelativeRootEnum.unSupportedFaxes}/download?${query}`,
  unmatchedServiceLineItemDownload: (query = '') =>
    `${RelativeRootEnum.eobfax}/${RelativeRootEnum.unmatchedEobs}/${RelativeRootEnum.serviceLineItems}/download?${query}`,
  oaiUserSearch: (query: string, cppuMenageQuery: CppuMenageQuery) =>
    `${query}${cppuMenageQuery.toEncodedQueryString()}`,
  userSearch: (query: string, cppuMenageQuery: CppuMenageQuery) => `${query}${cppuMenageQuery.toEncodedQueryString()}`,
  callJobClaimData: (jobId: string) => `${RelativeRootEnum.claims}/call-job-api-claim-data/${jobId}`,
  callJobAPIResource: (jobId: string) => `${RelativeRootEnum.claims}/call-job-api-claim-data/apidata/${jobId}`,
  callJobExtractionResource: (jobId: string, name: string) =>
    `${RelativeRootEnum.claims}/call-data-extraction/${jobId}/${name}`,
  claimsTenant: (claimId: string) => `${RelativeRootEnum.claims}/claim-tenant-owner/${claimId}`,
  cppuMenage: (cppuMenageQuery: CppuMenageQuery) =>
    `${RelativeRootEnum.cppuMenage}${cppuMenageQuery.toEncodedQueryString()}`,
  cppuMenageUnlinkable: (cppuMenageQuery: CppuMenageQuery) =>
    `${RelativeRootEnum.cppuMenageUnlinkable}${cppuMenageQuery.toEncodedQueryString()}`,
  cppuCognitoRefresh: () => `${RelativeRootEnum.cppuOaiUsers}/${RelativeRootEnum.cppuUsersCognitoRefresh}`,
  cppuCreateCustomer: () => `${RelativeRootEnum.cppuCustomers}`,
  cppuPatchCustomer: () => `${RelativeRootEnum.cppuCustomers}`,
  cppuCreatePractice: () => `${RelativeRootEnum.cppuPractices}`,
  cppuCreateOaiUser: () => `${RelativeRootEnum.cppuOaiUsers}`,
  cppuResendInvitation: (username: string) => `${RelativeRootEnum.cppuOaiUsers}/resend/${username}`,
  cppuChangePassword: (userName: string) => `${RelativeRootEnum.users}/reset-password/${userName}`,
  cppuDisableUser: (userId: string, status: boolean) => `${RelativeRootEnum.Enable}/${userId}/${status}`,
  cppuPatchOaiUser: () => `${RelativeRootEnum.cppuOaiUsers}`,
  cppuGetOaiUser: () => `${RelativeRootEnum.cppuOaiUsers}`,
  cppuUserSearch: (query: string, cppuMenageQuery: CppuMenageQuery) =>
    `${RelativeRootEnum.cppuOaiUsers}${query}${cppuMenageQuery.toEncodedQueryString()}`,
  csSearch: (query: string, cppuMenageQuery: CppuMenageQuery) => `${query}${cppuMenageQuery.toEncodedQueryString()}`,
  keycloakRefresh: (userId: string) => `${RelativeRootEnum.cppuOaiUsers}/${userId}/keycloak-refresh`,
  maintenanceNotification: () => `notifications`,
  loginDetails: (userId: string) => `${RelativeRootEnum.oaiUsers}/${userId}/${RelativeRootEnum.loginDetails}`,
}

const callServiceApiPaths = {
  callResource: (callId: string, resourceType: CallResourcesEnum, query = '') =>
    `${RelativeRootEnum.downloadCallResource}/${callId}/${resourceType}${query}`,
}
export const apiPaths = {
  ...claimServiceApiPaths,
  ...callServiceApiPaths,
}
